import React, { useContext } from "react";
import { Button, Checkbox } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import { observer } from "mobx-react";

import { StoresContext } from "../../pages/_app";
import { AMR_SOURCES } from "../../utils/constants";

const AnnotationAmrSourceFilter = () => {
  const rootStore = useContext(StoresContext);

  if (!rootStore.annotationStore.isAmr) {
    return null;
  }

  return (
    <Popover2
      position="bottom"
      content={
        <div className="amr-source-filter-menu">
          {AMR_SOURCES.map((source) => (
            <Checkbox
              key={source}
              label={source}
              checked={rootStore.annotationStore.amrSources.has(source)}
              onClick={() => rootStore.annotationStore.toggleAmrSource(source)}
            />
          ))}
        </div>
      }
    >
      <Button
        className="amr-source-filter-button"
        text="AMR Filters"
        rightIcon="double-caret-vertical"
      />
    </Popover2>
  );
};

export default observer(AnnotationAmrSourceFilter);
